webpackJsonp([1],{

/***/ "5mek":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9gGt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__ = __webpack_require__("Ovdt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c720c35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__ = __webpack_require__("Lqlx");
function injectStyle (ssrContext) {
  __webpack_require__("pGoM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c720c35"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c720c35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "9iUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("B2UH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3993de32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("ngp1");
function injectStyle (ssrContext) {
  __webpack_require__("TwGY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3993de32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "B2UH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Footer'
};

/***/ }),

/***/ "GgDs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("JBW2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b50393_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("T8B5");
function injectStyle (ssrContext) {
  __webpack_require__("5mek")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11b50393_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JBW2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Header'
};

/***/ }),

/***/ "Lqlx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":4}},[_c('h3',[_vm._v("Add Node")]),_vm._v(" "),_c('el-button',{staticClass:"flow-btn",attrs:{"type":"primary","plain":""},on:{"click":function($event){_vm.addNode('startNode',0)}}},[_vm._v("Start Node")]),_vm._v(" "),_c('el-button',{staticClass:"flow-btn",attrs:{"type":"primary","plain":""},on:{"click":function($event){_vm.addNode('processNode',1)}}},[_vm._v("Process Node")]),_vm._v(" "),_c('el-button',{staticClass:"flow-btn",attrs:{"type":"primary","plain":""},on:{"click":function($event){_vm.addNode('endNode',2)}}},[_vm._v("End Node")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":20}},[_c('div',{ref:"flow-container",staticClass:"flow-container"})])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":20}},[_c('h3',[_vm._v("Edit Chart")]),_vm._v(" "),_c('el-button',{staticClass:"flow-btn",attrs:{"type":"success","round":""},on:{"click":_vm.saveChart}},[_vm._v("Save Chart")]),_vm._v(" "),_c('el-button',{staticClass:"flow-btn",attrs:{"type":"warning","round":""},on:{"click":_vm.loadChart}},[_vm._v("Load Chart")]),_vm._v(" "),_c('el-button',{staticClass:"flow-btn",attrs:{"type":"danger","round":""},on:{"click":_vm.clearChart}},[_vm._v("Clear Chart")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 4, maxRows: 14},"placeholder":"Please Inpute The Json Config Of FlowChart"},model:{value:(_vm.chartConfig),callback:function ($$v) {_vm.chartConfig=$$v},expression:"chartConfig"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43ed7a9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("f/wO");
function injectStyle (ssrContext) {
  __webpack_require__("cBx5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43ed7a9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43ed7a9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__("zL8q");

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__("tvR6");

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false; // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

_vue2.default.use(_elementUi2.default);

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: {
    App: _App2.default
  }
});

/***/ }),

/***/ "Ovdt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flowchart = __webpack_require__("Rn3S");

var _flowchart2 = _interopRequireDefault(_flowchart);

var _uuid = __webpack_require__("P0XF");

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Demo',
  data: function data() {
    return {
      nodeConfig: {
        basicX: 250,
        basicY: 20,
        endY: 350,
        newX: 50,
        newY: 50
      },
      chart: null,
      nodes: [],
      chartConfig: ''
    };
  },

  methods: {
    /** 添加流程节点
     * @augments
     * @param name 节点类型
     */
    addNode: function addNode(name) {
      var nodeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (this.chart) {
        this.nodes.push(name);

        // 添加节点
        var startY = this.nodeConfig.basicY * this.nodes.length;
        this.chart.addNode(name, this.nodeConfig.basicX, startY, {
          class: 'node', // 自定义节点样式
          data: { // 节点绑定数据，在click事件中可以获取
            name: name
          },
          nodeType: nodeType,
          id: _uuid2.default.getUUID
        });
      }
    },
    saveChart: function saveChart() {
      if (this.chart) {
        this.chartConfig = this.chart.toJson();
        this.$message.success('The FlowChart Save Success!');
      } else {
        this.$message.error('The FlowChart Has Not Be Initiald');
      }
    },
    loadChart: function loadChart() {
      if (this.chart) {
        this.chart.clear();
        this.chart.fromJson(this.chartConfig);
        this.$message.success('The FlowChart Load Success!');
      } else {
        this.$message.error('The FlowChart Has Not Be Initiald');
      }
    },
    clearChart: function clearChart() {
      if (this.chart) {
        this.chart.clear();
        this.$message.success('The FlowChart Remove Success!');
      } else {
        this.$message.error('The FlowChart Has Not Be Initiald');
      }
    }
  },
  created: function created() {
    var _this = this;

    _flowchart2.default.ready(function () {
      // 初始化
      // 创建画布
      _this.chart = new _flowchart2.default(_this.$refs['flow-container'], {
        onNodeClick: function onNodeClick(data) {
          // 点击节点时触发的事件
          console.log(data);
        }
      });
    });
  }
};

/***/ }),

/***/ "P0XF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @class UUID
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UUID = function () {
  function UUID() {
    (0, _classCallCheck3.default)(this, UUID);
  }

  (0, _createClass3.default)(UUID, null, [{
    key: 'getUUID',

    /**
         *  获取随机UUID
         */
    get: function get() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }]);
  return UUID;
}();

exports.default = UUID;

/***/ }),

/***/ "Rn3S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _isNan = __webpack_require__("MICi");

var _isNan2 = _interopRequireDefault(_isNan);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsplumb = __webpack_require__("3eaK");

var _cache = __webpack_require__("TuU3");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @class 流程节点
 */
/**
 * flowchart.js - flowchartjs for create the flowchart
 *
 * @file
 * @author  lonly
 * @version 1.0.0
 * @license The MIT License: Copyright (c) 2010-2017 Lonly.
 */
var ChartNode = function () {
  /**
   * @class 流程节点
   * @param {Object} container      节点容器（画布），jquery对象
   * @param {String} id      节点id
   * @param {String} name    节点名称
   * @param {Number} type    节点类型 [0:'开始节点', 1:'流程节点', 2:'结束节点']
   * @param {Number} x       节点x坐标
   * @param {Number} y       节点y坐标
   * @param {Object} [options] 节点附加属性
   * @param {String} [options.color] 节点文字颜色
   * @param {String} [options.bgColor] 节点背景色
   * @param {Number} [options.radius] 节点圆角大小
   * @param {Number} [options.data] 绑定到节点的附加数据
   * @param {Number} [options.container] 节点容器（画布），若设置此选项则会自动将节点添加到画布上
   * @param {Boolean} [options.removable=true] 是否支持删除功能（鼠标放上去显示关闭图标）
   */
  function ChartNode(id, name, type, x, y, options) {
    (0, _classCallCheck3.default)(this, ChartNode);

    this._jsPlumb = null;
    this._container = null;
    this._id = id;
    this._name = name;
    this._x = x;
    this._y = y;
    this._clsName = options.class || '';
    this._data = options && options.data || {};
    this._data.nodeId = id;
    this._data.nodeType = type;
    this._options = (0, _assign2.default)({ // 默认属性
      removable: true
    }, options);
    this._el = null;

    if (options && options.container) {
      this.appendTo(options.container);
    }
  }

  (0, _createClass3.default)(ChartNode, [{
    key: 'getId',
    value: function getId() {
      return this._id;
    }
  }, {
    key: 'getData',
    value: function getData() {
      return this._data || {};
    }
  }, {
    key: 'getPos',
    value: function getPos() {
      return {
        x: this._x,
        y: this._y
      };
    }
  }, {
    key: 'setPlumb',
    value: function setPlumb(plumb) {
      this._jsPlumb = plumb;
    }
  }, {
    key: '_px',
    value: function _px(value) {
      return value + 'px';
    }
  }, {
    key: 'appendTo',
    value: function appendTo(container) {
      if (!container) {
        console.error('node container is null !');
        return;
      }

      var self = this;
      var options = self._options;
      var px = self._px;

      // 创建并插入 dom 节点
      var node = document.createElement('div');
      node.classList.add('window', 'task', '' + self._clsName);
      node.setAttribute('id', self._id);
      node.style.left = px(self._x);
      node.style.top = px(self._y);
      node.innerHTML = self._name;
      _cache.cache.addData(node, 'data', this._data);
      _cache.cache.addData(node, 'node', this);

      if (options.removable) {
        var removeIcon = document.createElement('div');
        removeIcon.classList.add('remove');
        node.append(removeIcon);
      }

      container.append(node);
      this._jsPlumb.draggable(node, {
        grid: [10, 10]
      });

      this._el = node;
    }
    /**
     * 添加连接端口
     * @param {Object} options 连接端口参数
     * @param {String} [options.color=#0096f2] 端口颜色
     * @param {Boolean} [options.isSource=false] 是否为源端口
     * @param {Boolean} [options.isTarget=false] 是否为目标端口
     * @param {String} [options.label] 端口名称
     * @param {String} [options.position=bottom] 端口位置，可设置为 'Top'
     */

  }, {
    key: 'addPort',
    value: function addPort(options) {
      var pos = options.position || 'Bottom';
      var anchors = ChartNode.anchorPos[pos];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(anchors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var anchor = _step.value;

          // 定义节点的基本配置
          var endpointConf = {
            anchor: anchor,
            isSource: !!options.isSource,
            isTarget: !!options.isTarget,
            maxConnections: -1,
            overlays: [ChartNode.arrowStyle, ['Label', {
              location: ChartNode.labelPos[pos],
              label: options.label || ''
            }]],
            allowLoopback: false,
            dragAllowedWhenFull: options.dragAllowedWhenFull || true
            // console.log('endpointConf', endpointConf)
          };this._jsPlumb.addEndpoint(this._el, endpointConf);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'updatePos',
    value: function updatePos() {
      var el = this._el;
      this._x = parseInt(el.style.left.toString().replace('px', ''), 10);
      this._y = parseInt(el.style.top.toString().replace('px', ''), 10);
    }
  }, {
    key: 'toPlainObj',
    value: function toPlainObj() {
      var item = this;
      item.updatePos();

      var data = (0, _assign2.default)({}, item._data);
      data.nodeId = item._id;
      data.positionX = item._x;
      data.positionY = item._y;
      data.className = item._clsName;
      data.removable = item._options.removable;

      return data;
    }
  }, {
    key: 'dispose',
    value: function dispose() {
      var el = this._el;
      this._jsPlumb.remove(el);
    }
  }], [{
    key: 'lineStyle',
    get: function get() {
      return {
        lineWidth: 5,
        joinstyle: 'round',
        strokeStyle: '#445566'
      };
    }
  }, {
    key: 'labelPos',
    get: function get() {
      return {
        TopBottom: [6, 2.5, 6, -2.5],
        Bottom: [6, 2.5],
        Top: [6, -2.5]
      };
    }
  }, {
    key: 'anchorPos',
    get: function get() {
      return {
        TopBottom: ['Top', 'Bottom'],
        Bottom: ['Bottom'],
        Top: ['Top']
      };
    }
  }, {
    key: 'arrowStyle',
    get: function get() {
      return ['Arrow', {
        location: 0.7
      }, {
        foldback: 0.7,
        width: 12
      }];
    }
  }]);
  return ChartNode;
}();

/**
 * @class 画布
 */


var Chart = function () {
  /**
   * FlowChart初始化
   * @param {Dom} container 挂在点
   * @param {Object} options 自定义事件{onNodeClick: 节点点击事件, onNodeDel: 节点删除事件}
   */
  function Chart(container, options) {
    (0, _classCallCheck3.default)(this, Chart);

    this._jsPlumb = null; // 多实例支持！
    this._container = container;
    this._nodes = [];
    this._seedName = 'flow-chart-node';
    this._seedId = 0;
    this.init(options);
  }
  // jsPlumb只有等到DOM初始化完成之后才能使用


  (0, _createClass3.default)(Chart, [{
    key: 'nodeId',
    value: function nodeId() {
      return this._seedName + this._seedId++ + new Date().valueOf();
    }
  }, {
    key: 'getNodes',
    value: function getNodes() {
      return this._nodes;
    }
    /**
     * jsPlumb初始化
     * @param {Object} options 自定义事件{onNodeClick: 节点点击事件, onNodeDel: 节点删除事件}
     */

  }, {
    key: 'init',
    value: function init(options) {
      var _this = this;

      this._jsPlumb = _jsplumb.jsPlumb.getInstance();
      // jsPlumb默认配置
      var defaultSetting = {
        DragOptions: {
          cursor: 'pointer',
          zIndex: 5000
        }, // 拖动时鼠标停留在该元素上显示指针，通过css控制
        PaintStyle: {
          lineWidth: 5,
          stroke: '#445566'
        }, // 元素的默认颜色
        HoverPaintStyle: {
          stroke: '#ec9f2e',
          lineWidth: 4
        },
        Endpoint: ['Dot', {
          radius: 5
        }], // 连接点的默认形状
        EndpointStyle: {
          radius: 9,
          fill: '#acd',
          stroke: 'red'
        }, // 连接点的默认颜色
        EndpointHoverStyle: {
          fill: '#ec9f2e',
          stroke: '#acd'
        },
        Anchors: ['Bottom'], // 连接点的默认位置
        Connector: ['Bezier', {
          curviness: 50
        }], // 连接线的默认样式
        ConnectionOverlays: [ChartNode.arrowStyle]
        // 加载默认配置
      };this._jsPlumb.importDefaults(defaultSetting);

      if (!this._container) {
        return;
      }

      this._container.classList.add('flow-chart-canvas-lkiarest');

      // 点击事件
      if (options && options.onNodeClick) {
        this._container.addEventListener('click', function (event) {
          var target = event.target;
          if (target.getAttribute('class').indexOf('task') >= 0) {
            options.onNodeClick.call(_this, target.getAttribute('node'));
          }
        });
      }
      // 删除节点
      this._container.addEventListener('click', function (event) {
        // let delNode = event.target.parentElement.getAttribute('data-chartnode')
        var delNode = _cache.cache.getData(event.target.parentElement, 'node');
        if (delNode && event.target.getAttribute('class').indexOf('remove') >= 0) {
          var data = delNode.getData();
          var nodeId = delNode.getId();
          delNode.dispose();

          _this.removeNode(nodeId);

          if (options && options.onNodeDel) {
            options.onNodeDel.call(_this, data);
          }
        }

        event.stopPropagation();
      });
    }
    /**
     * 添加新节点
     * @param {String} name    节点名称
     * @param {Number} type    节点类型 [0:'开始节点', 1:'流程节点', 2:'结束节点']
     * @param {Number} x       节点x坐标
     * @param {Number} y       节点y坐标
     * @param {Object} options 节点参数，可参考 {class ChartNode} 构造参数
     * @param {String} [options.id] 节点id，若未定义则由系统自动分配
     */

  }, {
    key: 'addNode',
    value: function addNode(name, x, y, options) {
      var id = options && options.id || this.nodeId;
      var type = options && !(0, _isNan2.default)(options.nodeType) ? options.nodeType : 1;
      var node = new ChartNode(id, name, type, x, y, options);
      node.setPlumb(this._jsPlumb);
      node.appendTo(this._container);
      this._nodes.push(node);

      // 添加端口
      var isSource = false;
      var isTarget = false;
      var position = 'Bottom';
      switch (type) {
        case 0:
          isSource = true;
          break;
        case 2:
          isTarget = true;
          position = 'Top';
          break;
        default:
          isSource = true;
          isTarget = true;
          position = 'TopBottom';
      }
      node.addPort({
        isSource: isSource,
        isTarget: isTarget,
        position: position,
        // label: 'custom label',
        dragAllowedWhenFull: true
      });

      return node;
    }
    /**
     * 删除节点
     * @param {String} nodeId    节点Id
     */

  }, {
    key: 'removeNode',
    value: function removeNode(nodeId) {
      var nodes = this._nodes;
      for (var i = 0, len = nodes.length; i < len; i++) {
        var node = nodes[i];
        if (node.getId() === nodeId) {
          node.dispose();
          nodes.splice(i, 1);
          return node;
        }
      }
    }
    /**
     * 序列化以保存
     */

  }, {
    key: 'toJson',
    value: function toJson() {
      // 获取所有节点
      var nodes = [];
      this._nodes.forEach(function (item) {
        nodes.push(item.toPlainObj());
      });

      // 获取所有连接
      var connections = this._jsPlumb.getConnections().map(function (connection) {
        return {
          connectionId: connection.id,
          pageSourceId: connection.sourceId,
          pageTargetId: connection.targetId,
          anchors: connection.endpoints.map(function (endpoint) {
            return endpoint.anchor.type;
          })
        };
      });

      return (0, _stringify2.default)({
        nodes: nodes,
        connections: connections
      });
    }
    /**
     * 从Json中加载Chart
     * @param {String} jsonStr    chart配置文件
     */

  }, {
    key: 'fromJson',
    value: function fromJson(jsonStr) {
      var _this2 = this;

      if (!jsonStr || jsonStr === '') {
        console.error('draw from json failed: empty json string');
        return;
      }

      var jsonObj = null;

      try {
        jsonObj = JSON.parse(jsonStr);
      } catch (e) {
        console.error('invalid json string', e);
        return;
      }

      this.clear();

      var nodes = jsonObj.nodes;
      var connections = jsonObj.connections;

      if (nodes) {
        nodes.forEach(function (item) {
          var node = _this2.addNode(item.name, item.positionX, item.positionY, {
            class: item.className,
            removable: item.removable,
            id: item.nodeId,
            nodeType: item.nodeType,
            data: item
          });

          _this2._jsPlumb.repaint(node.getId());
        });
      }

      if (connections) {
        connections.forEach(function (item) {
          _this2._jsPlumb.connect({
            source: item.pageSourceId,
            target: item.pageTargetId,
            anchors: item.anchors,
            deleteEndpointsOnDetach: false
          });
        });
      }

      this._jsPlumb.repaintEverything();
    }
    /**
     * 清空所有节点
     */

  }, {
    key: 'clear',
    value: function clear() {
      if (this._nodes) {
        this._nodes.forEach(function (item) {
          item.dispose();
        });
      }

      this._nodes = [];
    }
  }, {
    key: 'dispose',
    value: function dispose() {
      this.clear();
      this._container.off('click'); // unbind events
      this._container = null;
    }
  }], [{
    key: 'ready',
    value: function ready(callback) {
      _jsplumb.jsPlumb.ready(callback);
    }
  }]);
  return Chart;
}();

exports.default = Chart;

/***/ }),

/***/ "T8B5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h1',[_vm._v("A Simple FlowChart Libary Base On JsPlumb")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TuU3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @class 数据缓存
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cache = undefined;

var _weakMap = __webpack_require__("XFB5");

var _weakMap2 = _interopRequireDefault(_weakMap);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cache = function () {
  function Cache() {
    (0, _classCallCheck3.default)(this, Cache);

    this._caches = null;
    this.init();
  }

  (0, _createClass3.default)(Cache, [{
    key: 'init',
    value: function init() {
      if (!this._caches) {
        this._caches = new _weakMap2.default();
      }
    }
  }, {
    key: 'addData',
    value: function addData(owner, name, data) {
      // 根据Element获取相应仓库存储的空间
      var cache = this._caches.get(owner);
      // 如果获取不到，则开辟空间
      if (!cache) {
        cache = {};
        // 放到WeakMap对象中
        this._caches.set(owner, cache);
      }
      // 挂数据
      cache[name] = data;
      return cache;
    }
  }, {
    key: 'getData',
    value: function getData(owner, name) {
      // 根据Element获取相应仓库存储的空间
      var cache = this._caches.get(owner);
      // name为undefined的时候返回全部data，否则返回name指定的data
      return name === undefined ? cache : cache && cache[name];
    }
  }, {
    key: 'removeData',
    value: function removeData(owner, name) {
      var cache = this._caches.get(owner);
      // name为undefined的时候删除owner下的所有数据，否则只删除name指定的data
      if (!cache) {
        if (name) {
          cache[name] = undefined;
        } else {
          cache = undefined;
        }
      }
    }
  }, {
    key: 'clearData',
    value: function clearData() {
      this._caches = new _weakMap2.default();
    }
  }]);
  return Cache;
}();

var cache = exports.cache = new Cache();

/***/ }),

/***/ "TwGY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Demo = __webpack_require__("9gGt");

var _Demo2 = _interopRequireDefault(_Demo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '/',
    name: 'Demo',
    component: _Demo2.default
  }]
});

/***/ }),

/***/ "cBx5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f/wO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('t-header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('t-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ngp1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h4',[_vm._v("A Simple FlowChart Libary Base On JsPlumb")]),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/lonly197/flowchartjs"}},[_vm._v("Host on GitHub")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pGoM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Header = __webpack_require__("GgDs");

var _Header2 = _interopRequireDefault(_Header);

var _Footer = __webpack_require__("9iUS");

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//

exports.default = {
  name: 'App',
  components: {
    't-header': _Header2.default,
    't-footer': _Footer2.default
  }
};

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b7f9d42ac16b34462efa.js